import BaseAPI from '@/apis/base/baseApi';
import httpClient from "@/apis/base/httpclient";
import Qs from "qs";

class WebsiteAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'website';

	search(url) {
		let request = {
			url: `${this.getAPIUrl()}/search?url=${url}`,
		};

		return httpClient.getAsync(request);
	}
	getDomainMindMap(url) {
		let request = {
			url: `${this.getAPIUrl()}/get_domain_mind_map?url=${url}`,
		};
		return httpClient.getAsync(request);
	}

	query(payload) {
		let queryString = Qs.stringify(payload || {});
		let request = {
			url: `${this.getAPIUrl()}/query?${queryString}`,
		};

		return httpClient.getAsync(request);
	}

	researchDomain(domain) {
		let request = {
			url: `${this.getAPIUrl()}/research?domain=${domain}`
		};

		return httpClient.getAsync(request);
	}
}

export default new WebsiteAPI();
